import React, {useState, useEffect} from 'react';
import './SearchBoxes.scss';
import SearchBox from '../../atoms/SearchBox/SearchBox';
import MessageBox from '../../atoms/MessageBox/MessageBox';
import {getData} from '../../services/GetData';
import {AgroButton} from 'agrofy-ui-components';
import update from 'immutability-helper';
import { useTranslation } from 'react-i18next';
import {searchBoxGTMClick} from '../../services/gtmEvents';

function SearchBoxes({machinerySearch, sparePartsSearch, categoryName}) {
  
    const apiGatewayUrl = process.env.RAZZLE_API_GATEWAY_URL || window.env.RAZZLE_API_GATEWAY_URL;
    const { t } = useTranslation();
    const [radioChecked, setRadioChecked] = useState('radio1');
    const [warningMessage, setWarningMessage] = useState('');

    const [boxStates, setBoxStates] = useState(
        [
          {
            headerLabel: t('category'),
            options: machinerySearch,
            selectedOption:null,
            isMandatory: true,
            isEnabled: true,
            isWarning:false,
            urlAction:'/category-home/spare-parts/associated-categories',
            urlParameters: ['?categoryId='],
          },
          {
            headerLabel: `${(radioChecked === 'radio1')?t('equipment'):t('spare_part_type')}`,
            options:[],
            selectedOption:null,
            isMandatory: true,
            isEnabled: false,
            isWarning:false,
            urlAction:'/category-home/spare-parts/associated-equipments',
            urlParameters: ['?categoryId='],
          },
          {
            headerLabel: t('brand'),
            options:[],
            selectedOption:null,
            isMandatory: false,
            isEnabled: false,
            isWarning:false,
            urlAction:'/category-home/spare-parts/compatible-brands',
            urlParameters: ['?categoryId='],
          },
          {
            headerLabel: t('model'),
            options:[],
            selectedOption:null,
            isMandatory: false,
            isEnabled: false,
            isWarning:false,
            urlAction:'/category-home/spare-parts/compatible-models',
            urlParameters: ['?categoryId=', '&brandId=', '&brandLabel='],
          }
        ]
      );

      const [isDataLoading, setIsDataLoading] = useState(-1);

      useEffect(() => {
        if(boxStates[0].selectedOption){
              const tempState = update(boxStates, {0: {isEnabled: {$set: false}}});
              setBoxStates(tempState);

              const fetchData = () => {
                getData({url: `${apiGatewayUrl}${boxStates[1].urlAction}${boxStates[1].urlParameters[0]}${boxStates[0].selectedOption.Value}`})
                  .then(resp => {
                    let newState = null;
                    if(resp && resp.data){
                      newState = update(boxStates, {0: {isEnabled: {$set: true}},
                                                    1: {options: {$set: resp}, isEnabled: {$set: true}}});
                      setIsDataLoading(-1);
                    }
                    else{
                      const allOption = {...boxStates[0].selectedOption};
                      radioChecked == "radio1" ? t('all') : t('all_spare_parts');
                      allOption.Url = '';
                      newState = update(boxStates, {0: {isEnabled: {$set: true}},
                                                    1: {options: {data: {$set: [allOption]}}, selectedOption: {$set: allOption}, isEnabled: {$set: true}}});
                      setIsDataLoading(2);                 
                    }
                    setBoxStates(newState);
                  });
              };
              fetchData();
        }
      }, [boxStates[0].selectedOption]);

    useEffect(() => {
        if(boxStates[1].selectedOption){
            const tempState = update(boxStates, {0: {isEnabled: {$set: false}},
                                                 1: {isEnabled: {$set: false}}});
            setBoxStates(tempState);

            const fetchData = () => {
            getData({url: `${apiGatewayUrl}${boxStates[2].urlAction}${boxStates[2].urlParameters[0]}${boxStates[1].selectedOption.Value}`})
                .then(resp => {
                  let newState = null;
                    if(resp && resp.data){
                      newState = update(boxStates, {0: {isEnabled: {$set: true}},
                                                    1: {isEnabled: {$set: true}},
                                                    2: {options: {$set: resp}, isEnabled: {$set: true}}});
                      setIsDataLoading(-1);
                    }
                    else{
                      const allOption = {...boxStates[1].selectedOption};
                      allOption.Label = t('all_brands');
                      allOption.Url = '';
                      newState = update(boxStates, {0: {isEnabled: {$set: true}},
                                                    1: {isEnabled: {$set: true}},
                                                    2: {options: {data: {$set: [allOption]}}, selectedOption: {$set: allOption}, isEnabled: {$set: true}}});
                      setIsDataLoading(3);
                    }
                  setBoxStates(newState);
                });
            };
            fetchData();
        }
      }, [boxStates[1].selectedOption]);

      useEffect(() => {
        if(boxStates[2].selectedOption){
          const tempState = update(boxStates, {0: {isEnabled: {$set: false}},
                                               1: {isEnabled: {$set: false}},
                                               2: {isEnabled: {$set: false}}});
          setBoxStates(tempState);


          if(boxStates[2].selectedOption.Url && boxStates[2].selectedOption.Url !== ''){
            const fetchData = () => {
              getData({url: `${apiGatewayUrl}${boxStates[3].urlAction}${boxStates[3].urlParameters[0]}${boxStates[1].selectedOption.Value}${boxStates[3].urlParameters[1]}${boxStates[2].selectedOption.Value}${boxStates[3].urlParameters[2]}${boxStates[2].selectedOption.Label}`})
              .then(resp => {
                  let newState = null;
                    if(resp && resp.data){
                      newState = update(boxStates, {0: {isEnabled: {$set: true}},
                                                    1: {isEnabled: {$set: true}},
                                                    2: {isEnabled: {$set: true}},
                                                    3: {options: {$set: resp}, isEnabled: {$set: true}}});
                    }
                    else{
                      const allOption = {...boxStates[2].selectedOption};
                      allOption.Label = t('all_models');
                      allOption.Url = '';
                      newState = update(boxStates, {0: {isEnabled: {$set: true}},
                                                    1: {isEnabled: {$set: true}},
                                                    2: {isEnabled: {$set: true}},
                                                    3: {options: {data: {$set: [allOption]}}, selectedOption: {$set: allOption}, isEnabled: {$set: true}}});
                    }
                  setBoxStates(newState);
                  setIsDataLoading(-1);
                });
            };
            fetchData();
          }else{
            const allOption = {...boxStates[2].selectedOption};
            allOption.Label = t('all_models');
            allOption.Url = '';
            const newState = update(boxStates, {3: {options: {data: {$set: [allOption]}}, selectedOption: {$set: allOption}, isEnabled: {$set: true}}});
            setBoxStates(newState);
            setIsDataLoading(-1);
          }
        }
      }, [boxStates[2].selectedOption]);

      const handleChangeRadio = (radio) => {
        setRadioChecked(radio);
        setWarningMessage('');
        let newState=null;
        switch(radio){
            case 'radio1':
              newState = update(boxStates, {0: {options: {$set: machinerySearch}, selectedOption: {$set: null}, isEnabled: {$set: true}, isMandatory: {$set: true}, isWarning: {$set: false}, headerLabel: {$set: t('category')}, urlAction: {$set: '/category-home/spare-parts/associated-categories'}},
                                            1: {options: {$set: []}, selectedOption: {$set: null}, isEnabled: {$set: false}, isMandatory: {$set: true}, isWarning: {$set: false}, headerLabel: {$set: t('equipment')}, urlAction: {$set: '/category-home/spare-parts/associated-equipments'}},
                                            2: {options: {$set: []}, selectedOption: {$set: null}, isEnabled: {$set: false}, isMandatory: {$set: false}, isWarning: {$set: false}, headerLabel: {$set: t('brand')}, urlAction: {$set: '/category-home/spare-parts/compatible-brands'}},
                                            3: {options: {$set: []}, selectedOption: {$set: null}, isEnabled: {$set: false}, isMandatory: {$set: false}, isWarning: {$set: false}, headerLabel: {$set: t('model')}, urlAction: {$set: '/category-home/spare-parts/compatible-models'}}});
                break;
            case 'radio2':
              newState = update(boxStates, {0: {options: {$set: sparePartsSearch}, selectedOption: {$set: null}, isEnabled: {$set: true}, isMandatory: {$set: true}, isWarning: {$set: false}, headerLabel: {$set: t('category')}, urlAction: {$set: '/category-home/spare-parts/child-categories'}},
                                            1: {options: {$set: []}, selectedOption: {$set: null}, isEnabled: {$set: false}, isMandatory: {$set: false}, isWarning: {$set: false}, headerLabel: {$set: t('spare_part_type')}, urlAction: {$set: '/category-home/spare-parts/child-categories'}},
                                            2: {options: {$set: []}, selectedOption: {$set: null}, isEnabled: {$set: false}, isMandatory: {$set: false}, isWarning: {$set: false}, headerLabel: {$set: t('brand')}, urlAction: {$set: '/category-home/spare-parts/child-brands'}},
                                            3: {options: {$set: []}, selectedOption: {$set: null}, isEnabled: {$set: false}, isMandatory: {$set: false}, isWarning: {$set: false}, headerLabel: {$set: t('model')}, urlAction: {$set: '/category-home/spare-parts/child-models'}}});
                break;
            default:
              break;
        }
        setBoxStates(newState);
      };
  
      const handleChange = (selectedOpt, index) => {
        if (boxStates[index].selectedOption !== selectedOpt) {
          setWarningMessage('');
          let newState=null;
          switch (index){
              case 0:
                setIsDataLoading(1);
                newState = update(boxStates, {0: {selectedOption: {$set: selectedOpt}, isWarning: {$set: false}},
                                              1: {selectedOption: {$set: null}, isEnabled: {$set: true}, isWarning: {$set: false}},
                                              2: {selectedOption: {$set: null}, isEnabled: {$set: false}, isWarning: {$set: false}},
                                              3: {selectedOption: {$set: null}, isEnabled: {$set: false}, isWarning: {$set: false}}});
                setBoxStates(newState);
                  break;
              case 1:
                setIsDataLoading(2);
                newState = update(boxStates, {1: {selectedOption: {$set: selectedOpt}, isWarning: {$set: false}},
                                              2: {selectedOption: {$set: null}, isEnabled: {$set: true}, isWarning: {$set: false}},
                                              3: {selectedOption: {$set: null}, isEnabled: {$set: false}, isWarning: {$set: false}}});
                setBoxStates(newState);
                  break;
              case 2:
                setIsDataLoading(3);
                newState = update(boxStates, {2: {selectedOption: {$set: selectedOpt}, isWarning: {$set: false}},
                                              3: {selectedOption: {$set: null}, isEnabled: {$set: true}, isWarning: {$set: false}}});
                setBoxStates(newState);
                  break;
              case 3:
                newState = update(boxStates, {3: {selectedOption: {$set: selectedOpt}, isWarning: {$set: false}}});
                setBoxStates(newState);
                  break;
          }
        }
      };

      const searchButtonClick = () => {
        let found = false;
        const updatedState = boxStates.map(state => {
          if(!state.selectedOption && state.isMandatory && !found){
            found = true;
            setWarningMessage(t('select') + ' ' + state.headerLabel.toLowerCase());
            return {...state, isWarning: true};
          }
          else{
            return {...state};
          }
        });
        setBoxStates(updatedState);
      }

      const closeMessageBox = () => {
        const updatedState = boxStates.map(state => {
          return {...state, isWarning: false};
        });
        setBoxStates(updatedState);
        setWarningMessage('');
      }

      const isReadyToSearch = () => {
        let result = true;
        boxStates.map(state => {
          if(state.isMandatory && !state.selectedOption){
            result = false;
          }
        });
        return result;
      }

      const getLink = () => {
        let categoryUrl='';
        let filterUrl='';
        
        const categories = boxStates.slice(0,2);
        const filters = boxStates.slice(2,4);
        
        categories.map(category => {
          if(category.selectedOption && category.selectedOption.Url){
            categoryUrl = category.selectedOption.Url;
          }
        });

        filters.map(filter => {
          if(filter.selectedOption && filter.selectedOption.Url){
            if(radioChecked === 'radio1'){
              filterUrl = filter.selectedOption.Url;
            }
            else{
              filterUrl += filter.selectedOption.Url;
            }
          }
        })
        
        return categoryUrl.concat(filterUrl);
      }

    return(
      <React.Fragment>
        <div className="search-boxes__radio">
            <div>
              <span className="search-boxes__radio__text">{t('search_by')} </span>
            </div>
            <div className={`radio search-boxes__radio__group ${isDataLoading !== -1 ? 'disabled':''}`}>
              <label className={`radio search-boxes__radio__text ${isDataLoading !== -1 ? 'disabled':''}`}>
              <input id="radio1" type="radio" name="searchGroup" className="hidden" checked={radioChecked === 'radio1'} onChange={() => handleChangeRadio('radio1')} disabled={isDataLoading !== -1}/>
              <span className="label" /><b>{t('machine')}</b>
              </label>
              <label className={`radio search-boxes__radio__text ${isDataLoading !== -1 ? 'disabled':''}`}>
              <input id="radio2" type="radio" name="searchGroup" className="hidden" checked={radioChecked === 'radio2'} onChange={() => handleChangeRadio('radio2')} disabled={isDataLoading !== -1} />
              <span className="label" /><b>{t('spare_part')}</b>
              </label>
            </div>
        </div>
        <div className="search-boxes">
            <SearchBox 
                optionItems={boxStates[0].options}
                parentCallback={selectedOpt => handleChange(selectedOpt, 0)}
                isMandatory={boxStates[0].isMandatory}
                isEnabled={boxStates[0].isEnabled}
                headerLabel = {(boxStates[0].selectedOption && boxStates[0].selectedOption.Label) ? boxStates[0].selectedOption.Label : boxStates[0].headerLabel}
                isWarning = {boxStates[0].isWarning}
                isDataLoading = {isDataLoading == 0}
            />
            <SearchBox 
                optionItems={boxStates[1].options && boxStates[1].options.data}
                parentCallback={selectedOpt => handleChange(selectedOpt, 1)}
                isMandatory={boxStates[1].isMandatory}
                isEnabled={boxStates[1].isEnabled}
                headerLabel = {(boxStates[1].selectedOption && boxStates[1].selectedOption.Label) ? boxStates[1].selectedOption.Label : boxStates[1].headerLabel}
                isWarning = {boxStates[1].isWarning}
                isDataLoading = {isDataLoading == 1}
            />
            <SearchBox 
                optionItems={boxStates[2].options && boxStates[2].options.data}
                parentCallback={selectedOpt => handleChange(selectedOpt, 2)}
                isMandatory={boxStates[2].isMandatory}
                isEnabled={boxStates[2].isEnabled}
                headerLabel = {(boxStates[2].selectedOption && boxStates[2].selectedOption.Label) ? boxStates[2].selectedOption.Label : boxStates[2].headerLabel}
                isWarning = {boxStates[2].isWarning}
                isDataLoading = {isDataLoading == 2}
            />
            <SearchBox 
                optionItems={boxStates[3].options && boxStates[3].options.data}
                parentCallback={selectedOpt => handleChange(selectedOpt, 3)}
                isMandatory={boxStates[3].isMandatory}
                isEnabled={boxStates[3].isEnabled}
                headerLabel = {(boxStates[3].selectedOption && boxStates[3].selectedOption.Label) ? boxStates[3].selectedOption.Label : boxStates[3].headerLabel}
                isWarning = {boxStates[3].isWarning}
                isDataLoading = {isDataLoading == 3}
            />
            {
              (isReadyToSearch() && isDataLoading == -1) ?
              <a href={getLink()} onClick={() => searchBoxGTMClick(radioChecked, boxStates, categoryName)} className="button">{t('search')}</a> :
              <AgroButton onClick={searchButtonClick}>{t('search')}</AgroButton>
            }
            {
              <MessageBox message={warningMessage} parentCallBack={() => closeMessageBox()} />
            }
        </div>
      </React.Fragment>
    );
}

export default SearchBoxes;